export default __webpack_public_path__ + "static/media/PlateBenderImg.f04f6cf6.jpg";